import React from 'react'

const Mark = ({ children }) => (
  <mark style={{ backgroundColor: '#c0ddff', color: 'inherit' }}>
    {children}
  </mark>
)

export default Mark
